var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ruH_narrowAllTopMobile",
    transform: "translate(-20.000000, -21.000000)",
    fill: "#369FF7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(20.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0,
    y: 0,
    width: 25,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0,
    y: 11.5,
    width: 25,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0,
    y: 23,
    width: 25,
    height: 2,
    rx: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuActive);
export default __webpack_public_path__ + "static/media/menu_active.0cb7f28e.svg";
export { ForwardRef as ReactComponent };